import { config } from "@fortawesome/fontawesome-svg-core";
import axios, { AxiosRequestConfig } from "axios";
import { AuthService } from "../services/AuthService";

const DEFAULT_TIMEOUT = 30000;

const apiClient = axios.create({
  // baseURL: process.env.REACT_APP_API_BASE_URL,
  // baseURL: "http://test.ekathvainnovations.com:9099",
  baseURL: "https://bfs.ekathvainnovations.com/api-service",
  // baseURL: "http://localhost:9099",
  timeout: DEFAULT_TIMEOUT,
  headers: {
    "Content-Type": "application/json",
  },
});


apiClient.interceptors.request.use((config) => {
  const token = AuthService.getAccessToken(); // new helper
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
});


apiClient.interceptors.response.use(
  (response) => {
    if (Array.isArray(response.data)) {
      return Object.assign([], response.data, { status: response.status || 200 });
    }
    return {
      ...response.data,
      status: response.status || 200,
    };
  },
  (error) => {
    if (error?.response?.data?.error?.message === "Invalid Token!") {
      AuthService.logout();
      window.location.href = `${window.location.origin}/login?session=true`;
    }
    return Promise.reject(error?.response || error);
  }
);

class NetworkManager {
  static MyInstance;

  static getInstance() {
    if (!NetworkManager.MyInstance) {
      NetworkManager.MyInstance = new NetworkManager();
    }
    return NetworkManager.MyInstance;
  }

  apiClient = apiClient;

  appRequest = async (options) => {
    return apiClient(options);
  };
}

export { NetworkManager };
